module.exports = __webpack_public_path__ + "static/img/study.d1d314b4.svg";